import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@repo/core";
import type {
    ChangePasswordPayload,
    DeactivateAccountPayload,
} from "@repo/core";

/**
 * Profile self-service mutations (password change, account deactivation).
 *
 * Both hit the ANP host through `apiClient` — same JWT auth as the user
 * details endpoint, not the AWS Amplify API. This is the React Query
 * equivalent of anp-fe's `profileStore` actions.
 *
 * Neither hook toasts or navigates on its own: the backend answers with
 * per-field validation errors that the forms render inline, so error
 * handling deliberately stays with the caller.
 */

export const useChangePassword = () =>
    useMutation<{ detail?: string }, Error, ChangePasswordPayload>({
        mutationFn: async (payload) => {
            const { data } = await apiClient.changePassword(payload);
            return data;
        },
    });

export const useDeactivateAccount = () =>
    useMutation<{ detail?: string }, Error, DeactivateAccountPayload>({
        mutationFn: async (payload) => {
            const { data } = await apiClient.deactivateAccount(payload);
            return data;
        },
    });
